import { getStoryblokApi } from '@storyblok/react'

import { CampaignPopup } from '@definitions/types/storyblokTypes'
import { getStoryblokVersion } from '../../../helper/utils/getStoryblokVersion'
import { parseCampaignPopup } from '../parser/storyblokParsers'

/**
 * Fetches campaign popup configuration from Storyblok and parses it
 * @param brand - The brand prefix ('sunpoint' or 'wellmaxx')
 * @returns CampaignPopup or null if not found or inactive
 */
export async function fetchCampaignPopup(
  brand: 'sunpoint' | 'wellmaxx'
): Promise<CampaignPopup | null> {
  const storyblokApi = getStoryblokApi()

  // Story path format: {brand}/{brand}-settings-campaign-popup
  const storyPath = `${brand}/${brand}-settings-campaign-popup`

  try {
    const { data: campaignData } = await storyblokApi.get(
      `cdn/stories/${storyPath}`,
      {
        version: getStoryblokVersion(),
      }
    )

    if (!campaignData?.story?.content) {
      return null
    }

    return parseCampaignPopup(campaignData.story.content)
  } catch (error) {    
    // Only log in development for debugging
    if (process.env.NODE_ENV === 'development') {
      console.debug(
        `Campaign popup not found or unavailable for ${brand}:`,
        error
      )
    }
    return null
  }
}
